import { axios } from 'lib/axios'
import { endpoints } from 'utils/endpoints'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { ApiKey } from '../components/enums'

export type AddComment = {
  message: string
  userThreatId: number
  type: string
}

export const addComment = async (data: AddComment) => {
  return axios.post(endpoints.addComment, data)
}

export const useAddComment = () => {
  const queryClient = useQueryClient()
  return useMutation(addComment, {
    onSuccess: () => {
      queryClient.invalidateQueries([ApiKey.comment, ApiKey.message])
    },
  })
}
